import React from 'react';

export function handleButtonKeypress(
    e: React.KeyboardEvent<HTMLDivElement>,
    fnc: (e: React.KeyboardEvent<HTMLDivElement>) => void
) {
    if (e.code === 'Enter' || e.code === 'Space') {
        fnc(e);
    }
}
